import { render } from "./AreaTagComponent.vue?vue&type=template&id=3899ffae"
import script from "./AreaTagComponent.vue?vue&type=script&lang=js"
export * from "./AreaTagComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__